var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.056,
    clipPath: "url(#metamask_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2761B",
    stroke: "#E2761B",
    d: "M14.487 2.006 8.865 6.18l1.04-2.463 4.582-1.712Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    d: "M1.51 2.006 7.085 6.22l-.99-2.502L1.51 2.006Zm10.954 9.678-1.497 2.293 3.203.882.921-3.124-2.627-.051Zm-11.548.05.915 3.125 3.204-.882-1.498-2.293-2.621.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    d: "m4.854 7.808-.893 1.35 3.18.141-.112-3.418-2.175 1.927Zm6.288 0L8.938 5.842l-.073 3.457 3.175-.14-.898-1.351Zm-6.108 6.17 1.91-.933-1.65-1.288-.26 2.22Zm4.017-.933 1.916.932-.266-2.22-1.65 1.288Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    d: "m10.967 13.977-1.915-.932.153 1.249-.017.525 1.78-.842Zm-5.932 0 1.78.842-.011-.525.14-1.249-1.909.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233447",
    stroke: "#233447",
    d: "m6.843 10.932-1.593-.469 1.124-.514.47.983Zm2.311 0 .469-.983 1.13.514-1.599.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    stroke: "#CD6116",
    d: "m5.034 13.977.271-2.293-1.768.05 1.497 2.243Zm5.661-2.293.271 2.293 1.498-2.242-1.769-.051Zm1.345-2.526L8.865 9.3l.294 1.633.468-.983 1.13.514 1.283-1.305Zm-6.791 1.305 1.13-.514.463.983.3-1.633-3.181-.14 1.288 1.304Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4751F",
    stroke: "#E4751F",
    d: "m3.96 9.158 1.334 2.6-.045-1.295-1.288-1.305Zm6.798 1.305-.057 1.294 1.339-2.599-1.282 1.305ZM7.142 9.3l-.3 1.633.373 1.927.085-2.537L7.142 9.3Zm1.723 0-.153 1.017.068 2.543.379-1.927L8.865 9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    d: "m9.16 10.932-.38 1.928.271.186 1.65-1.288.056-1.294-1.598.47Zm-3.91-.469.045 1.294 1.65 1.288.271-.186-.373-1.927-1.593-.469Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    d: "m9.188 14.82.017-.526-.142-.125h-2.13l-.13.125.012.525-1.78-.842.622.509 1.26.876H9.08l1.266-.876.621-.509-1.78.842Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    stroke: "#161616",
    d: "m9.051 13.045-.27-.186H7.214l-.271.186-.141 1.249.13-.125h2.13l.14.125-.152-1.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    d: "m14.723 6.452.48-2.305-.717-2.141L9.051 6.04l2.09 1.768 2.955.864.656-.762-.283-.204.452-.412-.35-.271.452-.345-.3-.226ZM.797 4.147l.48 2.305-.305.226.452.345-.345.27.452.413-.282.204.65.762 2.954-.864 2.09-1.768L1.51 2.006l-.712 2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    d: "m14.097 8.672-2.955-.864.898 1.35-1.339 2.6 1.763-.023h2.627l-.994-3.063Zm-9.243-.864-2.955.864-.983 3.063h2.621l1.758.022L3.96 9.158l.893-1.35Zm4.011 1.491.187-3.26.858-2.321H6.097l.847 2.322.198 3.26.068 1.028.005 2.53H8.78l.012-2.53.073-1.029Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "metamask_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.d0704e5a97d7fd65fff458cbcaf2489c.svg";
export { ForwardRef as ReactComponent };